import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom'; // Added Link
import { useAuth } from '../../hooks/useAuth';

function Login() {
  const [username, setUsername] = useState(''); // Assuming your backend uses 'username'
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false); // For the "Remember me" checkbox
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  const from = location.state?.from?.pathname || "/dashboard";

  const validateForm = () => {
    if (!username || !password) {
      setError('Email/Username and password are required');
      return false;
    }
    setError('');
    return true;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateForm()) return;
    setLoading(true);
    setError('');

    try {
      // In your Next.js example, you had formData.get('email'). 
      // Ensure your login function and backend expect 'username' or 'email' as appropriate.
      // For this example, I'm sticking with 'username' as per your original React Login.js.
      await login(username, password); 
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.message || 'Authentication failed!');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8">
      <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">Sign In</h2>
      <form onSubmit={handleSubmit}>
        <div className="space-y-4">
          <div>
            <label 
              htmlFor="username" // Changed from 'email' to 'username' to match state
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Email or Username {/* Updated label text */}
            </label>
            <input 
              id="username" // Match htmlFor
              name="username" // Match state variable and what backend expects
              type="text" // Or "email" if you only accept email format
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-all"
              placeholder="your@email.com or username" // Updated placeholder
              required
            />
          </div>
  
          <div>
            <label 
              htmlFor="password"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Password
            </label>
            <input 
              id="password"
              name="password"
              type="password" 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-all"
              placeholder="••••••••"
              required
            />
          </div>
  
          <div className="flex items-center justify-between">
            <label className="flex items-center">
              <input 
                name="remember"
                type="checkbox" 
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500" // Use indigo for consistency with focus rings
              />
              <span className="ml-2 text-sm text-gray-600">Remember me</span>
            </label>
            <Link to="/forgot-password" className="text-sm text-primary hover:text-primary-hover font-medium"> {/* Use Link for SPA navigation */}
              Forgot password?
            </Link>
          </div>
  
          <button 
            type="submit"
            disabled={loading}
            className="w-full bg-primary hover:bg-primary-hover text-white font-medium py-2.5 rounded-lg transition-colors disabled:opacity-70"
          >
            {loading ? 'Signing In...' : 'Sign In'}
          </button>
        </div>
      </form>
      {error && <p className="mt-4 text-sm text-center text-red-600">{error}</p>}
  
      <div className="mt-6 text-center text-sm text-gray-600">
        Don't have an account? 
        <Link to="/register" className="text-primary hover:text-primary-hover font-medium"> {/* Use Link for SPA navigation */}
          {' '}Sign up
        </Link>
      </div>
    </div>
  );
}

export default Login;